import axios from '@/request';
import qs from 'qs';

export default {
  async stadiumUserList(params: any) {
    return axios.get('sys-stadium-user/list', { params });
  },
  async stadiumUserTrack(params: any) {
    return axios.get('sys-stadium-user/track', { params });
  },
  async count(params: any) {
    return axios.get('sys-stadium-user/count', { params });
  },
  async allOperationData(params: any) {
    return axios.get('sys-stadium-user/all-operation-data', { params })
  },
  async allCountData(params: any) {
    return axios.get('sys-stadium-user/all-count-data', { params })
  },
  async stadiumData(params: any) {
    return axios.get('sys-stadium-user/stadium-data', { params })
  },
  async enterapplyData(params: any) {
    return axios.get('sys-stadium-user/enterapply-data', { params })
  },
  async manager(params: any) {
    return axios.get('sys-stadium-user/manager', { params })
  }
};
